const c = {
  name: "WorldEurope",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,6.3c0.7,0,1.2-0.6,1.2-1.2S24.7,3.8,24,3.8c-0.7,0-1.2,0.6-1.2,1.2S23.3,6.3,24,6.3z"/>
		<path class="st0" d="M13.2,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C12.7,9.8,13.2,10.3,13.2,11z"
			/>
		<path class="st0" d="M21.2,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,9.8,21.2,10.3,21.2,11z"
			/>
		<path class="st0" d="M24,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.7,11.7,23.3,12.3,24,12.3z"
			/>
		<path class="st0" d="M29.2,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,9.8,29.2,10.3,29.2,11z"
			/>
		<path class="st0" d="M32,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.7,11.7,31.3,12.3,32,12.3z"
			/>
		<path class="st0" d="M15.2,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,12.8,15.2,13.3,15.2,14z"
			/>
		<path class="st0" d="M22,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.7,14.7,21.3,15.3,22,15.3z"
			/>
		<path class="st0" d="M27.2,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C26.7,12.8,27.2,13.3,27.2,14z"
			/>
		<path class="st0" d="M30,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.7,14.7,29.3,15.3,30,15.3z"
			/>
		<path class="st0" d="M35.2,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C34.7,12.8,35.2,13.3,35.2,14z"
			/>
		<path class="st0" d="M19.2,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C18.7,6.8,19.2,7.3,19.2,8z"/>
		<path class="st0" d="M22,9.3c0.7,0,1.2-0.6,1.2-1.2S22.7,6.8,22,6.8c-0.7,0-1.2,0.6-1.2,1.2S21.3,9.3,22,9.3z"/>
		<path class="st0" d="M27.2,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2s0.6-1.2,1.2-1.2C26.7,6.8,27.2,7.3,27.2,8z"/>
		<path class="st0" d="M30,9.3c0.7,0,1.2-0.6,1.2-1.2S30.7,6.8,30,6.8c-0.7,0-1.2,0.6-1.2,1.2S29.3,9.3,30,9.3z"/>
		<path class="st0" d="M13.2,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C12.7,15.8,13.2,16.3,13.2,17z"
			/>
		<path class="st0" d="M16,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C14.7,17.7,15.3,18.3,16,18.3z"
			/>
		<path class="st0" d="M21.2,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,15.8,21.2,16.3,21.2,17z"
			/>
		<path class="st0" d="M24,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.7,17.7,23.3,18.3,24,18.3z"
			/>
		<path class="st0" d="M29.2,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,15.8,29.2,16.3,29.2,17z"
			/>
		<path class="st0" d="M32,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.7,17.7,31.3,18.3,32,18.3z"
			/>
		<path class="st0" d="M37.2,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C36.7,15.8,37.2,16.3,37.2,17z"
			/>
		<path class="st0" d="M14,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.7,20.7,13.3,21.3,14,21.3z"
			/>
		<path class="st0" d="M19.2,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,18.8,19.2,19.3,19.2,20z"
			/>
		<path class="st0" d="M22,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.7,20.7,21.3,21.3,22,21.3z"
			/>
		<path class="st0" d="M27.2,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C26.7,18.8,27.2,19.3,27.2,20z"
			/>
		<path class="st0" d="M30,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.7,20.7,29.3,21.3,30,21.3z"
			/>
		<path class="st0" d="M35.2,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C34.7,18.8,35.2,19.3,35.2,20z"
			/>
		<path class="st0" d="M12,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.7,23.7,11.3,24.3,12,24.3z"
			/>
		<path class="st0" d="M17.2,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C16.7,21.8,17.2,22.3,17.2,23z"
			/>
		<path class="st0" d="M24,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.7,23.7,23.3,24.3,24,24.3z"
			/>
		<path class="st0" d="M29.2,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,21.8,29.2,22.3,29.2,23z"
			/>
		<path class="st0" d="M32,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.7,23.7,31.3,24.3,32,24.3z"
			/>
		<path class="st0" d="M37.2,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C36.7,21.8,37.2,22.3,37.2,23z"
			/>
		<path class="st0" d="M14,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.7,26.7,13.3,27.3,14,27.3z"
			/>
		<path class="st0" d="M19.2,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,24.8,19.2,25.3,19.2,26z"
			/>
		<path class="st0" d="M30,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C28.7,26.7,29.3,27.3,30,27.3z"
			/>
		<path class="st0" d="M35.2,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C34.7,24.8,35.2,25.3,35.2,26z"
			/>
		<path class="st0" d="M12,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.7,29.7,11.3,30.3,12,30.3z"
			/>
		<path class="st0" d="M17.2,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C16.7,27.8,17.2,28.3,17.2,29z"
			/>
		<path class="st0" d="M20,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.7,29.7,19.3,30.3,20,30.3z"
			/>
		<path class="st0" d="M25.2,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,27.8,25.2,28.3,25.2,29z"
			/>
		<path class="st0" d="M28,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C26.7,29.7,27.3,30.3,28,30.3z"
			/>
		<path class="st0" d="M33.2,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C32.7,27.8,33.2,28.3,33.2,29z"
			/>
		<path class="st0" d="M10,33.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C8.8,32.7,9.3,33.3,10,33.3z"/>
		<path class="st0" d="M15.2,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,30.8,15.2,31.3,15.2,32z"
			/>
		<path class="st0" d="M18,33.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.7,32.7,17.3,33.3,18,33.3z"
			/>
		<path class="st0" d="M23.2,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,30.8,23.2,31.3,23.2,32z"
			/>
		<path class="st0" d="M26,33.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.7,32.7,25.3,33.3,26,33.3z"
			/>
		<path class="st0" d="M31.2,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,30.8,31.2,31.3,31.2,32z"
			/>
		<path class="st0" d="M16,36.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C14.7,35.7,15.3,36.3,16,36.3z"
			/>
		<path class="st0" d="M21.2,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,33.8,21.2,34.3,21.2,35z"
			/>
		<path class="st0" d="M24,36.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.7,35.7,23.3,36.3,24,36.3z"
			/>
		<path class="st0" d="M39.3,14.9c0.4,1.4,0.6,2.9,0.6,4.3h0c0,0.3,0,0.6,0,0.8s0,0.5,0,0.8c0,1.4-0.3,2.9-0.6,4.3
			c-0.2,0.9-0.5,1.7-0.8,2.5c-0.2,0.4-0.3,0.8-0.5,1.1l0,0.1c-0.3,0.7-0.7,1.3-1.1,2c-0.3,0.5-0.6,0.9-0.9,1.3
			c-0.5,0.6-1,1.2-1.5,1.8c-0.3,0.3-0.6,0.6-0.9,0.9c-0.7,0.6-1.3,1.1-2,1.6c-1.2,0.9-2.6,1.6-3.9,2.1c-0.8,0.3-1.6,0.6-2.5,0.8
			c-0.7,0.2-1.3,0.3-1.9,0.4h-0.1c-0.5,0.1-1.1,0.2-1.8,0.2c-0.4,0-0.8,0-1.3,0c-0.4,0-0.9,0-1.3,0c-0.7-0.1-1.3-0.1-1.8-0.2h0
			c-0.6-0.1-1.3-0.2-1.9-0.4c-0.9-0.2-1.7-0.5-2.5-0.8C4.9,35.5,0,28.2,0,20C0,9,9,0,20,0c4.1,0,8.1,1.2,11.5,3.6
			c0.7,0.5,1.3,1,2,1.6c0.3,0.3,0.6,0.6,0.9,0.9c0.5,0.5,1.1,1.2,1.5,1.8c0.3,0.4,0.6,0.8,0.9,1.3c0.4,0.7,0.8,1.3,1.1,2l0.1,0.1
			c0.2,0.4,0.3,0.7,0.5,1.1C38.8,13.2,39.1,14.1,39.3,14.9z M29.2,35c0,0.2,0,0.3-0.1,0.5c0.4-0.2,0.8-0.5,1.2-0.8
			c0.3-0.2,0.5-0.4,0.8-0.6c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.5,0.8-0.8c-0.1-0.2-0.1-0.3-0.1-0.5
			c0-0.7,0.6-1.2,1.2-1.2c0.1,0,0.3,0,0.4,0.1c0.2-0.3,0.5-0.7,0.7-1c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.7,0.6-1.2,1.2-1.2
			c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c0.2-0.3,0.3-0.6,0.4-1c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0-0.1-0.1-0.2-0.1-0.4
			c0-0.4,0.2-0.8,0.5-1c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.1,0.1-0.2c0.3-1.1,0.5-2.2,0.5-3.3c-0.7,0-1.2-0.6-1.2-1.2s0.5-1.2,1.2-1.2
			c-0.1-1.1-0.2-2.2-0.5-3.3c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.2c-0.3-0.2-0.5-0.6-0.5-1c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1
			c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.3-0.3-0.7-0.5-1c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c-0.7,0-1.2-0.6-1.2-1.2c0-0.3,0.1-0.6,0.3-0.8
			c-0.2-0.3-0.4-0.7-0.7-1c-0.1,0-0.2,0.1-0.4,0.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0.1-0.4,0.1-0.5c-0.3-0.3-0.5-0.5-0.8-0.8
			c-0.3-0.2-0.5-0.4-0.8-0.7c-0.1-0.1-0.2-0.1-0.3-0.2c-0.2-0.2-0.5-0.4-0.8-0.6c-0.4-0.3-0.8-0.5-1.2-0.8c0.1,0.2,0.1,0.3,0.1,0.5
			c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.6,0.5-1.1,1.1-1.2C25.4,2.6,22.7,2,20,2C10.1,2,2,10.1,2,20
			c0,6.5,3.4,12.3,8.9,15.5c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2c0,0.6-0.5,1.1-1.1,1.2
			c0.1,0,0.1,0.1,0.2,0.1c0.3,0.1,0.5,0.2,0.8,0.4c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0.1c0.1,0,0.3-0.1,0.4-0.1
			c0.4,0,0.8,0.2,1,0.5c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0,0.2,0.1c0.5,0.1,0.9,0.2,1.4,0.3c0.1-0.5,0.6-1,1.2-1
			c0.7,0,1.2,0.6,1.2,1.2c0.5,0,1,0,1.5,0c0-0.7,0.6-1.2,1.2-1.2c0.6,0,1,0.4,1.2,1c0.5-0.1,0.9-0.2,1.4-0.3c0.1,0,0.1,0,0.2-0.1
			c0.1,0,0.1,0,0.2-0.1c0.2-0.3,0.6-0.5,1-0.5c0.1,0,0.3,0,0.4,0.1c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,0.7-0.3,1-0.5
			c-0.6-0.1-1.1-0.6-1.1-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,33.8,29.2,34.3,29.2,35z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as WorldEurope
};
